import { ENVIRONMENT } from "@/base/environment"
import { AnalyticsBrowser } from "@segment/analytics-next"

import type { AnalyticsClient } from "./analytics-client"

export const SEGMENT_CLIENT = AnalyticsBrowser.load(
  {
    writeKey: ENVIRONMENT.segmentWriteKey ?? "",
  },
  {
    disable: ENVIRONMENT.segmentWriteKey !== ``,
  },
)
SEGMENT_CLIENT satisfies AnalyticsClient
